import { useState, useEffect } from 'react';

import { CziViewer } from 'features/image-viewer/modules/czi-viewer/CziViewer';

export const ImageViewerPage = () => {
    return (
        <CziViewer />
    );
};